import { Grid } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles()(function (theme) { return ({ paddingRight: { paddingRight: 16 } }); });
export function TableActionPanel(props) { var styles = useStyles().classes; return /*#__PURE__*/ _jsx(Grid, { children: /*#__PURE__*/ _jsx("div", { className: styles.paddingRight, children: /*#__PURE__*/ _jsx(Grid, { container: true, spacing: 1, alignItems: "center", children: props.children }) }) }); }
